import { reactive, computed, getCurrentInstance, ComponentInternalInstance, ref, Ref } from '@vue/composition-api';
import dayjs from 'dayjs';
import { encode } from 'js-base64';
import smh, { SMH } from '@/renderer/scripts/smh';
import passwordHandler from '@/renderer/components/user/compositions/passwordHandler';
type ResetTokenDetail = {
  accountName: string;
  avatar: string;
  expireTime: string;
  nickname: string;
  isModified: boolean;
};
type Handler = {
  resetToken: string;
  loading: Ref<boolean>;
  resetDetail: ResetTokenDetail;
  isExpired: Ref<boolean>;
  resetDone: Ref<boolean>;
  methods: {
    getDetail: () => Promise<void>;
    reset: (params: SMH.ResetNewPasswordParams) => Promise<boolean>;
  };
};
export default function resetPasswordHandler(): Handler {
  const currComponent = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const resetDetail = reactive({
    accountName: '',
    avatar: '',
    expireTime: '',
    expireTimeStr: '',
    nickname: '',
    isModified: false,
  });
  const { token } = vm.$route.params;
  const { getResetTokenDetail, resetNewPassword } = passwordHandler();
  const loading = ref(false);
  const resetDone = ref(false);
  const isExpired = ref(false);
  const methods = {
    // 获取邀请码信息
    async getDetail() {
      loading.value = true;
      const detail = await getResetTokenDetail(token);
      if (!detail) return;
      loading.value = false;
      Object.assign(resetDetail, {
        ...detail,
        expireTimeStr: dayjs(detail.expireTime).format('YYYY-MM-DD HH:mm:ss'),
      });
      const now = dayjs();
      isExpired.value = dayjs(detail.expireTime).isBefore(now);
    },
    async reset(params: SMH.ResetNewPasswordParams) {
      Object.assign(params, {
        accountPassword: encode(params.accountPassword),
      });
      return await resetNewPassword(params);
    },
  };
  return {
    resetToken: token,
    loading,
    isExpired,
    resetDetail,
    resetDone,
    methods,
  };
}
